var pagelist = require('./modules/view');

module.exports = pagelist;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.pagelist.mobile/app/index.js